import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { Dialog } from './dialog';
export function ManageMentorship() {
    const { mentorshipId } = useParams();
    const isUpdate = Boolean(mentorshipId) && mentorshipId !== 'new';
    return _jsx(Dialog, { isUpdate: isUpdate });
}
